var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0082C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1509 8.49554C10.1391 8.49316 10.1269 8.49406 10.1156 8.49812C10.1043 8.50219 10.0943 8.50927 10.0867 8.5186C10.0816 8.52511 10.0778 8.53261 10.0756 8.54064C10.0735 8.54867 10.073 8.55705 10.0742 8.56528C10.0754 8.5735 10.0783 8.58139 10.0827 8.58846C10.0871 8.59552 10.0929 8.60161 10.0997 8.60635C12.5629 10.394 9.05681 14.4867 2.25 10.1313C8.02125 15.5622 16.0577 9.56316 10.1509 8.49554ZM6.86362 6.10604C1.75275 7.74122 7.60781 11.5977 8.11575 9.64979C8.11801 9.64165 8.11858 9.63315 8.11743 9.62479C8.11627 9.61643 8.11342 9.60839 8.10905 9.60117C8.10468 9.59395 8.09887 9.58771 8.092 9.58281C8.08512 9.57792 8.07732 9.57449 8.06906 9.57272C8.05723 9.56965 8.04479 9.56984 8.03306 9.57329C7.281 9.81797 3.13931 8.65979 6.86362 6.10604ZM15.75 7.08872C11.3248 3.9331 3.02175 6.53522 7.30519 8.76329C7.32049 8.77103 7.33819 8.77261 7.35462 8.76769C7.37105 8.76277 7.38497 8.75173 7.3935 8.73685C7.39803 8.72842 7.40053 8.71905 7.40083 8.70948C7.40112 8.69992 7.39919 8.69042 7.39519 8.68172C5.65313 5.00072 14.5018 6.1201 15.75 7.08872ZM12.078 11.6737C14.4174 10.6105 12.5151 6.9706 9.42075 7.67316C9.40413 7.6769 9.38671 7.67399 9.3722 7.66506C9.3577 7.65613 9.34726 7.64187 9.34313 7.62535C9.34046 7.61396 9.34117 7.60205 9.34516 7.59106C9.34916 7.58007 9.35627 7.57049 9.36562 7.56347C11.7731 5.75447 16.2922 9.97772 12.078 11.6737Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSys);
export default __webpack_public_path__ + "static/media/sys.5f77da5b91b0c817a2e0ce68ee195cdc.svg";
export { ForwardRef as ReactComponent };